import { langUtil } from '@/components/language/util';
import { _getInfo, _historyRecord } from '@/services/activity';
import { _getAllServersOfGame } from '@/services/data';
import { Activity } from '@/types/activity';
import { Template } from '@/types/template';
import { getActiveAuth } from '@/utils/getActiveAuth';
import { message } from 'antd';
import { cloneDeep } from 'lodash';
import { useCallback, useState } from 'react';
import { history as routerHistory } from 'umi';
import { _getActivityConfig, _getSystemConfig, _getTest } from './../services/template';
/**
 * 活动信息model（可用于活动创建页和活动详情页）
 */
interface IGetInfoParams {
  id: number; //活动id
  checkPage?: boolean; //是否需要检查当前页面路径，需要则根据逻辑进行跳转
  useFlow?: boolean; //是否需要流程步骤信息，用新建活动创建页面,初始化时使用即可
  useSystem?: boolean; //是否需要系统配置信息
  useHistoryRecords?: boolean; //是否需要历史版本配置信息
  notServers?: boolean; //是否需要产品服务器数据，默认全部场景都需要
  isReportTab?: boolean;
}
export default () => {
  const [initLoading, setInitLoading] = useState(true); //初始化加载
  const [info, setInfo] = useState<Activity.IInfo | null>();
  const [system, setSystem] = useState<Template.ISystem | null>();
  const [history, setHistory] = useState<Activity.IInfo[]>([]);
  //活动左侧可切换列表
  const [tabs, setTabs] = useState<any>([]);
  //当前产品对应的服务器列表
  const [servers, setServers] = useState<Server.IBase[]>([]);
  const [allConfigCards, setAllConfigCards] = useState<Template.IActivityConfig>();
  const getInfo = useCallback((params: IGetInfoParams) => {
    //获取活动等初始化信息,
    //获取基本信息 - 根据当前的状态判断进入哪个页面
    // 若进入编辑流程页 - 获取对应模板的各种信息
    return _getInfo({
      id: params.id
    }).then(async (d: Activity.IInfo) => {
      //判断是否需要核对进入页面的正确性
      if (params.checkPage) {
        const { trafficAuth, operateNoAuth } = await getActiveAuth(d.product.code);
        //判断是否需要核对进入页面的正确性
        if (d.activeType === 'traffic' && !trafficAuth) {
          message.info('暂无该页面权限');
          routerHistory.push('/activity/list');
          return;
        }
        if (d.activeType === 'operate' && operateNoAuth) {
          message.info('暂无该页面权限');
          routerHistory.push('/activity/list');
          return;
        }

        if ([1, 2, 3, 4].includes(d.status)) {
          //强制跳转到活动页面
          if (!window.location.href.includes('/activity/flow')) {
            window.location.href = '/smart/activity/flow/' + params.id;
          }
        } else {
          if (d.typeCls === 1 && d.abTestId && params.isReportTab) {
            window.location.href = `/abtest/experiment/smartDetail?id=${d.abTestId}&&smartId=${d.id}`;
            return;
          }
          //强制跳转到活动详情页面
          if (!window.location.href.includes('/activity/detail')) {
            window.location.href = '/smart/activity/detail/' + params.id;
          }
        }
      }
      setInfo(d);
      //流程所需数据
      if (params.useFlow) {
        //同步获取其对应的模板内的活动配置步骤和测试配置
        Promise.all([
          _getActivityConfig({
            id: d.template.id,
            version: d.template.version
          }),
          _getTest({
            id: d.template.id,
            version: d.template.version
          })
        ]).then(([config, test]: [Template.IActivityConfig, Template.ITest]) => {
          setAllConfigCards(cloneDeep(config));
          let tbs = [],
            configStep = 0; //配置步骤，从0开始
          if (config && config.processList) {
            //存在活动配置，则添加活动参数tabs
            config.processList.forEach((p: Template.TProcess, index) => {
              tbs.push({
                key: configStep.toString(),
                label: langUtil.get(p.name),
                process: {
                  ...p,
                  isFirst: index === 0, //是否为第一步
                  isLast: index === config.processList.length - 1 //是否为最后一步
                },
                test, //测试配置
                uiType: 'process'
              });
              configStep++;
            });
          }
          if (test && test.useTest) {
            tbs.push({
              key: configStep.toString(),
              label: '推送测试',
              test,
              uiType: 'test'
            });
            configStep++;
          }
          //默认最后一步为正式发布和配置回顾,在该页面支持灰度发布功能
          tbs.push({
            key: configStep.toString(),
            label: '活动发布',
            test,
            uiType: 'publish'
          });
          //设置流程数据
          setTabs(tbs);
        });
      }
      //系统配置数据
      if (params.useSystem) {
        _getSystemConfig({
          id: d.template.id,
          version: d.template.version
        }).then((d) => setSystem(d));
      }
      //服务器数据，默认全部场景都需要
      if (!params.notServers) {
        _getAllServersOfGame({
          code: d.product.code,
          activityId: d.id //该字段为获取该产品的测试服列表
        }).then((s) => setServers(s || []));
      }
      //必须是原活动才支持获取历史版本信息配置
      if (params.useHistoryRecords && !d.originVersionId) {
        _historyRecord({
          id: d.id
        }).then((d) => setHistory(d || []));
      }

      return d;
    });
  }, []);

  return {
    initLoading,
    setInitLoading,
    //活动信息
    info,
    setInfo,
    getInfo,
    history,
    tabs, //当前活动的全流程左侧tabs
    //对应的模板系统配置
    system,
    //服务器
    servers,
    allConfigCards
  };
};
